import {Component, ElementRef, HostListener, OnInit} from '@angular/core';
import {global} from 'src/globals';
import {Globals} from "../../../classes/Globals";
import {auth} from "../../../../services";
import _ from 'lodash';
import {Router} from "@angular/router";
import {SessionService} from "../../../services/data/session.service";

@Component({
	selector: 'main-topbar',
	templateUrl: './topbar.component.html',
	styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit {

	global: Globals = global;
	activeButton: boolean = false;

	constructor(private router: Router, private elementRef: ElementRef, public sessionService: SessionService) {
	}

	@HostListener('document:click', ['$event'])
	@HostListener('document:touchstart', ['$event'])
	handleOutsideClick(event: Event) {
		if (!this.elementRef.nativeElement.contains(event.target)) {
			this.activeButton = false;
		}
	}

	ngOnInit() {
	}

	account() {
	}

	passwordChange() {
		auth.passwordChangeModal();
	}

	logout() {
		return this.sessionService.logout()
			.then(() => {
				auth.clear(false);
				auth.loginModal('/')
			});
	}

}
